// AuthorCard.jsx
import React from "react";
import authorConfig from '../../config/authorConfig.js';
import './authorCard.css';

const AuthorCard = ({ author }) => {
  const { name, img, since, profit, method, images = [] } = authorConfig[author];

  const formattedProfit = profit.toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0
  });

  const now = new Date();
  const yearsElapsed = now.getFullYear() - since;

  let tenureText;
  if (yearsElapsed < 2) {
    // Assume start date is November of the 'since' year
    const startDate = new Date(since, 10, 1); // Month index 10 = November
    let monthDiff =
      (now.getFullYear() - startDate.getFullYear()) * 12 +
      (now.getMonth() - startDate.getMonth());
    if (monthDiff < 0) monthDiff = 0;
    // Round up to the nearest 3 months
    const monthsRounded = Math.ceil(monthDiff / 3) * 3;
    tenureText = `${monthsRounded} months`;
  } else {
    tenureText = `${yearsElapsed} ${yearsElapsed === 1 ? 'year' : 'years'}`;
  }

  return (
    <div className="author-banner">
      <div className="grid-fixed g2">
        <div className="col left">
          <div className="avatar-wrapper">
            {images.slice(0, 3).map((src, i) => (
              <img
                key={i}
                src={src}
                alt=""
                className={`avatar-back avatar-back-${i + 1}`}
              />
            ))}

            <img
              src={img}
              alt={`Matched Edge ${name}`}
              className="avatar-main"
            />
          </div>
        </div>

        <div className="col right">
          <h4>{name}</h4>
          <p className="since">Matched betting since {since}</p>
          <p className="profit">
            {`${formattedProfit} over ${tenureText}`}
          </p>
          <p className="method">{method}</p>
        </div>
      </div>
    </div>
  );
};

export default AuthorCard;
